import View from './view';

class AssetView extends View {
  constructor(asset) {
    super(asset);

    this.uniqueAgreementTypes = this.uniqueAgreements();
  }

  GI_SIMPLIFICATION_RESTRICTED_COLLECTIONS = [
    'NBA',
    'NCL',
    'NLC',
    'PMA',
    'SPI',
    'SIC',
  ];

  isEditorialCalculatorRestrictedAsset = () =>
    this.GI_SIMPLIFICATION_RESTRICTED_COLLECTIONS.indexOf(
      this.collectionCode
    ) !== -1;

  isDownloadable = () =>
    this.agreementDetails?.length > 0 && !this.isRestricted();

  isRestricted = () => this.isBlocked || this.hidden || this.isOffline;

  isPurchaseable = () =>
    !this.uniqueAgreementTypes.includes('PA') &&
    !this.uniqueAgreementTypes.includes('ED') &&
    !this.uniqueAgreementTypes.includes('RF') &&
    !this.isRestricted();

  isViewOnly = () =>
    !this.isDownloadable() && this.agreementDetails?.length > 0;

  isCoveredByPA = () => {
    if (this.agreementDetails) {
      return this.agreementDetails.some((agreement) => agreement.Type === 'PA');
    }
    return false;
  };

  isCoveredByRF = () => {
    if (this.agreementDetails) {
      return this.agreementDetails.some((agreement) => agreement.Type === 'RF');
    }
    return false;
  };

  isPaViewOnly = () => {
    if (this.agreementDetails) {
      return this.agreementDetails.some(
        (agreement) =>
          agreement.Type === 'PA' &&
          agreement.Permissions?.length === 1 &&
          agreement.Permissions?.includes('Search')
      );
    }
    return false;
  };

  isImage = () => this.assetType?.toLowerCase() === 'image';

  isFilm = () => this.assetType?.toLowerCase() === 'film';

  isVideoTemplate = () => this.assetType?.toLowerCase() === 'videotemplate';

  isCreative = () => this.family?.toLowerCase() === 'creative';

  isEditorial = () => this.family?.toLowerCase() === 'editorial';

  isRoyaltyFree = () => this.licenseType?.toLowerCase() === 'rf';

  isRightsManaged = () => this.licenseType?.toLowerCase() === 'rm';

  isRightsReady = () => this.licenseType?.toLowerCase() === 'rr';

  uniqueAgreements = () => {
    const result = [];
    if (this.agreementDetails) {
      this.agreementDetails.forEach((agreement) => result.push(agreement.Type));
    }
    return result;
  };
}

export default /** @type {new (asset: unknown) => import('../types/assetView.types').AssetView} */ (
  AssetView
);
